<template>
    <div id="sendsms">
        <headers :title="titles"></headers>
        <div class="message">
            <p class="msg_title">短信内容</p>
            <div class="msg_txt"
                 v-if="msg.sid==22">
                <p>{{msg.content}}</p>
            </div>
            <div v-else>
                <textarea maxlength='200'
                          @input='smsChange'
                          v-model="content"></textarea>
            </div>
        </div>
        <div class="title">其他</div>
        <div class="wraps bottom">
            <p @click="setStu">
                短信通知
                <span class="up">
                    {{stuName}}
                    <i class="icon-zhankai"></i>
                </span>
            </p>
            <p @click="setMima">
                是否下发账号密码
                <span class="up">
                    {{mima}}
                    <i class="icon-zhankai"></i>
                </span>
            </p>
        </div>
        <!-- 弹窗 -->
        <!-- 选择学生 -->
        <transition name="my-slide3"
                    tag="div">
            <div class="bottomChoose"
                 v-show="stuShow">
                <ul>
                    <li v-for="(stu,index) in chooseStu"
                        :key="index"
                        @click="Student(index)">{{stu.name}}</li>
                </ul>
            </div>
        </transition>
        <!-- 是否发账号密码 -->
        <transition name="my-slide2"
                    tag="div">
            <div class="bottomChoose"
                 v-show="mimaShow">
                <ul>
                    <li v-for="(o,index) in chooseMima"
                        :key="index"
                        @click="Mima(index)">{{o.name}}</li>
                </ul>
            </div>
        </transition>
        <transition name="my-fade"
                    tag="div">
            <div class="bottomMask"
                 @click="hideMask"
                 v-show="stuShow||mimaShow"></div>
        </transition>
        <div class="foot"
             @click="go">下发短信</div>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'SRC/components/base/header.vue';

export default {
    data () {
        return {
            message_id: this.$route.query.message_id,
            city_id: localStorage.getItem('city_id'),
            stuShow: false,//弹窗
            mimaShow: false,//弹窗
            stuName: "班内所有学生",
            mima: "否",
            chooseStu: [{
                name: "班内所有学生",
                id: 0
            }, {
                name: "仅开通学生",
                id: 1
            }],
            chooseMima: [{
                name: "是",
                id: 1
            }, {
                name: "否",
                id: 0
            }],
            stuId: 0,
            mimaId: 0,
            titles: '下发作业短信',
            isSend: true,
            content: '',
            sms_type: 1
        }
    },
    components: {
        headers
    },
    mounted () {
        this.content = this.msg.content;
    },
    computed: {
        msg () {
            return this.$store.state.msg;
        },
    },
    beforeRouteLeave (to, from, next) {
        layer.closeAll();
        next();
    },
    methods: {
        smsChange () {
            this.sms_type = 2;
            this.content = this.content.trim().slice(0, 200);
        },
        setStu () {//短信通知
            this.stuShow = true;
        },
        Student (i) {
            this.stuName = this.chooseStu[i].name;
            this.stuId = this.chooseStu[i].id;
            this.stuShow = false;
        },
        setMima () {
            this.mimaShow = true;
        },
        Mima (i) {
            this.mima = this.chooseMima[i].name;
            this.mimaId = this.chooseMima[i].id;
            this.mimaShow = false;
        },
        hideMask () {
            this.stuShow = false;
            this.mimaShow = false;
        },
        go () {
            if (!this.content.length) {
                layer.open({
                    content: '短信不能为空',
                    skin: 'msg',
                    time: 2
                });
                return false;
            }
            if (this.content.length > 200) {
                layer.open({
                    content: '短信内容已超过200字',
                    skin: 'msg',
                    time: 2
                });
                return false;
            }
            if (!this.isSend) return false;
            let that = this;
            layer.open({
                type: 2,
                shadeClose: false,
                content: '发送中'
            });
            this.isSend = false;
            let msgData = {};
            msgData.unit_class_ids = this.msg.unit_class_ids;
            msgData.message_id = this.message_id;
            msgData.content = this.content;
            msgData.sms_scope = this.stuId;
            msgData.send_pwd = this.mimaId;
            msgData.sid = this.msg.sid;
            msgData.phone = this.msg.phone;
            msgData.params = JSON.stringify(this.msg.params);
            msgData.sms_id = this.msg.sms_id;
            msgData.sms_type = this.sms_type;
            msgData.place_id = 6;//配置平台发送短信配置参数
            if (this.city_id == "411600") {
                msgData.sms_type = 2;
            }
            this.$http.post(API_URL_TASK_API + '/public/task/tea/send/message', msgData).then(res => {
                if (res.data.response == 'ok') {
                    layer.alert('发送成功', 'tea', function () {
                        layer.closeAll();
                        that.$router.go(-2);
                    })
                } else {
                    layer.closeAll()
                    layer.open({
                        content: res.data.message,
                        skin: 'msg',
                        time: 2
                    });
                }
                this.isSend = true;
            })
        },
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

#sendsms {
    padding-bottom: 120px / $ppr;
    textarea {
        width: 633px / $ppr;
        margin: 0 auto;
        display: block;
        height: 190px / $ppr;
        color: #999;
        background: #f7f7f7;
        padding: 0.25rem 0.5rem;
        border-radius: 0.25rem;
        border: none;
        font-size: 0.7rem;
        line-height: 1.2rem;
    }
}

.icon-zhankai {
    display: inline-block;
    width: 0.35rem;
    height: 0.65rem;
    background: url("./img/enter.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    top: 5px / $ppr;
}

.bottomMask {
    position: fixed;
    z-index: 998;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: $mask;
    transition: background-color 0.3s linear;
}

//底部弹层选择
.bottomChoose {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background-color: $c-fbg;
    transition: bottom 0.3s linear;
    li {
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        border-bottom: 1px / $ppr solid $line;
        text-align: center;
        font-size: 36px / $ppr;
        color: #333;
    }
}

.wraps {
    background-color: $c-fbg;
    p {
        font-size: $md;
        height: 90px / $ppr;
        line-height: 90px / $ppr;
        padding: 0 $w;
        span {
            float: right;
            color: $c-light;
            i {
                color: $c-light;
                margin-left: 15px / $ppr;
            }
        }
        .up,
        .down {
            color: $c-theme;
        }
    }
    p:nth-child(2) {
        border-top: 1px / $ppr solid $line;
    }
}

.title {
    height: 84px / $ppr;
    line-height: 84px / $ppr;
    padding: 0 $w;
    font-size: $md;
    background: #fff;
    margin-top: 24px / $ppr;
}

.foot {
    position: fixed;
    bottom: 0;
    height: $h-header;
    line-height: $h-header;
    width: 100%;
    background-color: $c-theme;
    color: $c-header;
    font-size: $lg;
    text-align: center;
}

.picker-backdrop,
.picker-wrapper {
    position: fixed;
    bottom: 0;
}

.message {
    width: 100%;
    margin: 0 auto;
    background: #fff;
    padding-bottom: 24px / $ppr;
    .msg_title {
        padding: 0 $w;
        height: 74px / $ppr;
        line-height: 90px / $ppr;
        font-size: 28px / $ppr;
        color: #333;
    }
    .msg_txt {
        width: 673px / $ppr;
        margin: 0 auto;
        background: #f7f7f7;
        color: #999;
        margin: 0 auto;
        border-radius: 10px / $ppr;
        p {
            padding: 10px / $ppr 20px / $ppr;
            line-height: 48px / $ppr;
        }
    }
}
.my-fade-enter,
.my-fade-leave-to {
    background-color: rgba(0, 0, 0, 0);
}
.my-slide1-enter,
.my-slide1-leave-to,
.my-slide2-enter,
.my-slide2-leave-to,
.my-slide3-enter,
.my-slide3-leave-to {
    bottom: -192px / $ppr;
}
</style>
